import React from 'react';

export default class TimelineIconMarkedWon extends React.Component {
  render() {
    return (
      <div className="timeline-point success text-center">
        <i className="fal fa-smile-beam fa-fw" />
      </div>
    );
  }
}
